import { pluginIcon } from '@/features/plugins/plugin-icons';
import { useWorkbench } from '@/features/plugins/use-plugin-workbench';
import { SIDE_PANEL_ITEMS, type SidePanelItem } from '@/lib/side-panel/side-panel-items';

/** Core panel items, with plugin-contributed panels overriding or extending them. */
export function usePanelItems(): readonly SidePanelItem[] {
  const workbench = useWorkbench();
  return [
    ...SIDE_PANEL_ITEMS.filter((item) => !workbench.panels.some((panel) => panel.view === item.id)),
    ...workbench.panels.map((panel) => ({
      ...SIDE_PANEL_ITEMS.find((item) => item.id === panel.view),
      id: panel.view,
      label: panel.title,
      icon: pluginIcon(panel.icon ?? 'app'),
      shortcut: panel.session?.shortcut,
      multiple: panel.session?.multiple,
      newInstanceLabel: panel.session?.newInstanceLabel,
      description: panel.description,
      iconSrc: panel.iconSrc,
    })),
  ];
}
